import { useNavigate } from "react-router";
import { Button } from "@unlimited-robotics/ur-ui-kit";
import React from "react";

import ICONS from "../../constants/icons";
import AppCard from "../../components/app-card/AppCard";
import Controls from "../../components/controls/Controls";
import PageOutline from "../../components/page-outline/PageOutline";
import DashboardWidgets from "../../components/dashboard-widget/DashboardWidgets";
import {
  AppsContainer,
  AppsContainerLot,
  AppsHeaderButton,
  AppsHeaderContainer,
  ShinyGreeting,
  WholeWrapper,
} from "./components";
import { useLocalApp, useInstalledApplications } from "../../hooks";

const demoApps = [
  {
    installedApplication: {
      application: {
        shortDescription: "Hear your favorite Spotify playlist",
        name: "Spotify - My Playlist",
        category: { icon: <ICONS.DashboardBattery /> },
        icon: { publicUrl: "https://xboxplay.games/uploadStream/7876.jpg" },
        url: "/spotify",
        id: "1",
      },
    },
  },
  {
    installedApplication: {
      application: {
        shortDescription: "Take a look at your favorite Pinterest saved posts and...",
        name: "My inspirations",
        category: { icon: <ICONS.DashboardBattery /> },
        icon: {
          publicUrl:
            "https://mlabs-s3-blog.s3.amazonaws.com/wp-content/uploads/2020/11/09170042/O_que_%C3%A9_Pinterest_header.png",
        },
        url: "/iframe",
        id: "2",
      },
    },
  },
  {
    installedApplication: {
      application: {
        shortDescription: "Take a look at your favorite Pinterest saved posts and...",
        name: "My Receipes",
        category: { icon: <ICONS.DashboardBattery /> },
        icon: {
          publicUrl:
            "https://www.goodfood.com.au/content/dam/images/g/u/g/z/n/e/image.related.wideLandscape.460x259.gugulj.png/1487805442937.jpg",
        },
        url: "/yummly",
        id: "3",
      },
    },
  },
  {
    installedApplication: {
      application: {
        shortDescription: "Take a look at your favorite Pinterest saved posts and...",
        name: "Washington Post - News",
        category: { icon: <ICONS.DashboardBattery /> },
        icon: {
          publicUrl:
            "https://www.washingtonpost.com/wp-apps/imrs.php?src=https://www.washingtonpost.com/wp-stat/store/newspaper.jpg&w=700&h=525&t=20191113b",
        },
        url: "/washington",
        id: "4",
      },
    },
  },
];

const HomeDemo = () => {
  const navigate = useNavigate();
  const { runApp } = useLocalApp();

  const { applications } = useInstalledApplications({
    robotId: "f3ff7986-b365-43ef-aaa3-b5b3f21b4275",
  });

  // let dummyApps;
  // if (applications) {
  //   dummyApps = [...applications, ...demoApps];
  // }

  // console.log(dummyApps);

  return (
    <PageOutline>
      {demoApps?.length ? (
        <WholeWrapper>
          <DashboardWidgets />
          <Controls />
          <ShinyGreeting>Good Afternoon! </ShinyGreeting>
          <AppsHeaderContainer>
            Your Apps
            <AppsHeaderButton>
              <Button
                onClick={() => {
                  navigate("/iframe");
                }}
                label="Explore More Apps"
                color="light_blue"
              />
            </AppsHeaderButton>
          </AppsHeaderContainer>
          <AppsContainerLot>
            <AppsContainer>
              {console.log("apps", applications)}
              {demoApps &&
                demoApps?.map((app, i) => (
                  <AppCard
                    key={i}
                    {...app?.installedApplication?.application}
                    onClick={() => {
                      const appId = app?.installedApplication?.application?.id;
                      const url = app?.installedApplication?.application?.url;

                      if (url) {
                        navigate(url);
                      }
                      if (!appId) {
                        console.log("App has no ID to start!");
                      } else {
                        runApp(appId);
                        if (appId === "4ffde989-ac50-4ef2-9057-a7a5c491331c") {
                          navigate("/music");
                        }
                      }
                    }}
                  />
                ))}
            </AppsContainer>
          </AppsContainerLot>
        </WholeWrapper>
      ) : (
        <></>
      )}
    </PageOutline>
  );
};

export default HomeDemo;
